/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateCnuContactRequestJobMutationRequest,
  CreateCnuContactRequestJobMutationResponse,
  CreateCnuContactRequestJob400,
} from '../types/CreateCnuContactRequestJob'

function getCreateCnuContactRequestJobUrl() {
  const res = { method: 'POST', url: `/api/v1/contact_request/cnu/` as const }
  return res
}

/**
 * @description Queryset + filter provider for the university vertical.
 * The unified ``/opportunities/`` engine owns the list/summary surface; this
 * view exists only to (a) back the ``<university_id>`` detail route and (b)
 * supply the filtered queryset to the contact-request select-all path
 * (``CNUCreateContactRequestJobView``), which needs ``UniversityFilterSet``.
 * @summary Create a contact request job for colleges/universities
 * {@link /api/v1/contact_request/cnu/}
 */
export async function createCnuContactRequestJob(
  data: CreateCnuContactRequestJobMutationRequest,
  config: Partial<RequestConfig<CreateCnuContactRequestJobMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateCnuContactRequestJobMutationResponse,
    ResponseErrorConfig<CreateCnuContactRequestJob400>,
    CreateCnuContactRequestJobMutationRequest
  >({
    method: 'POST',
    url: getCreateCnuContactRequestJobUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
